// The fullstack's address (VUE_APP_FULLSTACK, a build constant). In development it is
// http://localhost:9001; when the Frontend is opened on another host (e.g. a phone on the local
// network at http://192.168.1.103:9000), the same host is used with the fullstack's port, so its
// links and requests reach this machine instead of the phone's own localhost.

const LOCAL_HOSTS = ["localhost", "127.0.0.1"];

// a localhost address, moved to the page's host when the page isn't on localhost
export function getLocalHostUrl(configured) {
  if (!configured || typeof window === "undefined") return configured;
  const url = new URL(configured);
  const pageHost = window.location.hostname;
  if (!LOCAL_HOSTS.includes(url.hostname) || LOCAL_HOSTS.includes(pageHost)) return configured;
  url.hostname = pageHost;
  return url.origin;
}

export function getFullstackUrl() {
  return getLocalHostUrl(process.env.VUE_APP_FULLSTACK);
}
